import { PagePlaceholder } from '../components/PagePlaceholder';

/**
 * Guest account area — "my bookings" (view / modify / cancel), saved details,
 * and favourites. Requires guest auth (separate identity from PMS staff).
 * Loyalty program is out of scope per product decision.
 */
export default function GuestAccountPage() {
  return (
    <PagePlaceholder title="My account">
      <p>Guest bookings, saved details, and favourites go here.</p>
    </PagePlaceholder>
  );
}
